import { defineMessages } from 'react-intl'

export default defineMessages({
  shareEvent: {
    id: 'share.share-event',
    defaultMessage: 'Share event',
  },
  shareEventText: {
    id: 'share.share-event-text',
    defaultMessage: 'Check out this event on Universe',
  },
  copyLink: {
    id: 'share.copy-link',
    defaultMessage: 'Copy link',
  },
  linkCopied: {
    id: 'share.link-copied',
    defaultMessage: 'Link copied',
  },
  more: {
    id: 'share.more',
    defaultMessage: 'More',
  },
})
